import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';

type TrackSearchFollowedPayload = TrackingPayload & {
    searchKeywords: string;
};

export const trackSearchFollowedAnalytics = (payload: TrackSearchFollowedPayload) => {
    track(TrackingEvents.Search.SearchFollowed, payload);
};
